import { DatePipe } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FacilityService } from 'src/app/core/services/facility.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { ExportService } from '../../services/export.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { noFullWidthValidator, dynamicMaxLengthValidator } from 'src/app/core/utils/validation-functions';
import { CommonDataService } from 'src/app/core/services/common-data.service';

@Component({
  selector: 'laas-export-header-edit',
  templateUrl: './export-header-edit.component.html',
  styleUrls: ['./export-header-edit.component.scss']
})
export class ExportHeaderEditComponent extends SessionBaseComponent implements OnInit {

  exportHeader: any;
  editForm: FormGroup;

  //options
  orgIdOptions: any[];
  forwarderOptions: any[];
  billObjectOptions: any[];
  billObjectTypeOptions: any[];
  shipMethodOptions: any[];
  docTypeOptions: any[];
  docType1Options: any[];
  currenyOptions: any[];
  exportCodeOptions: any[];
  consigneeOptions: any[];
  toCountryOptions: any[];
  toCityOptions: any[];
  allCityOptions: any[];
  isHkFacility: boolean;

  //dictionary
  consigneeDic: any[];
  docType1Dic: any[];
  columnNameMapping: {[key: string]: string} = {};

  constructor(
    injector: Injector,
    private exportService: ExportService,
    private facilityService: FacilityService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private commonDataService: CommonDataService,
    private dropdownOptionService: DropdownOptionsService,
  ) {
    super(injector);
    //options
    this.orgIdOptions = [];
    this.forwarderOptions = [];
    this.billObjectOptions = [];
    this.billObjectTypeOptions = [];
    this.shipMethodOptions = [];
    this.orgIdOptions = [];
    this.docTypeOptions = [];
    this.docType1Options = [];
    this.currenyOptions = [];
    this.exportCodeOptions = [];
    this.consigneeOptions = [];
    this.toCountryOptions = [];
    this.toCityOptions = [];
    this.allCityOptions = [];
    this.isHkFacility = false;

    //dictionary
    this.consigneeDic = [];
    this.docType1Dic = [];

    this.exportHeader = {
      facility: '',
      bookingForwarder: '',
      billObjectType: '',
      billObject: '',
      shipMethod: '',
      orgId: '',
      docType: '',
      docType1: '',
      exportCode: '',
      currency:'',
      exportType:'',
      exportAmount: null,
      exportNtdAmount: null,
      freeOnBoardAmount:null,
      freeOnBoardNtdAmount:null,
      freeOnBoardChargeAmount:null,
      mawbNo:'',
      expressBill:'',
      flyNo1:'',
      flyNo2:'',
      exchangeRate:null,
      reference:'',
      exportDtTimeZone: null,
      flyDt1TimeZone: null,
      flyDt2TimeZone: null,
      docNo1:'',
      docNo2:'',
      docNo3:'',
      docNo4:'',
      docNo5:'',
      consigneeKey:'',
      consigneeName:'',
      changeConsigneeId:'',
      changeConsigneeName:'',
      bookingNo: '',
      portOfLoadingDischargeName: '',
      toCountry: '',
      toCity: '',
      containerNo: '',
      typeOfPackage: '',
      consigneeCompany1: '',
      consigneeCompany2: '',
      consigneeAddress1: '',
      consigneeAddress2: '',
      letterOrgId: '',
    }

    this.editForm = this.formBuilder.group({
      bookingForwarder: '',
      billObjectType: '',
      billObject: '',
      shipMethod: '',
      orgId: '',
      docType: '',
      docType1: '',
      exportCode: '',
      currency:'',
      exportType:'',
      exportAmount: null,
      exportNtdAmount:null,
      freeOnBoardAmount:null,
      freeOnBoardNtdAmount:null,
      freeOnBoardChargeAmount:null,
      mawbNo: ['', [Validators.maxLength(25)]],
      expressBill: ['', [Validators.maxLength(25)]],
      flyNo1: ['', [dynamicMaxLengthValidator(() => this.getFlyNo1MaxLength())]],
      flyNo2: ['', [Validators.maxLength(17)]],
      exchangeRate:null,
      reference:'',
      exportDtTimeZone: null,
      flyDt1TimeZone: null,
      flyDt2TimeZone: null,
      docNo1: ['', [Validators.maxLength(2), noFullWidthValidator()]],
      docNo2: ['', [Validators.maxLength(2), noFullWidthValidator()]],
      docNo3: ['', [Validators.maxLength(2), noFullWidthValidator()]],
      docNo4: ['', [Validators.maxLength(4), noFullWidthValidator()]],
      docNo5: ['', [Validators.maxLength(5), noFullWidthValidator()]],
      consigneeKey:'',
      consigneeName:'',
      changeConsigneeId:'',
      changeConsigneeName:'',
      bookingNo: ['', [Validators.maxLength(50)]],
      portOfLoadingDischargeName: ['', [Validators.maxLength(50)]],
      toCountry: '',
      toCity: '',
      containerNo: ['', [Validators.maxLength(200)]],
      typeOfPackage: '',
      consigneeCompany1: '',
      consigneeCompany2: '',
      consigneeAddress1: '',
      consigneeAddress2: '',
      letterOrgId: '',
    });

  }

  get f() {
    return this.editForm.controls;
  }

  get getMaxLengthErrorMessage() {
    if (this.f.docNo1.errors?.maxlength) {
      return `第一節段字元限制：${this.f.docNo1.errors?.maxlength.requiredLength}`;
    }
    if (this.f.docNo2.errors?.maxlength) {
      return `第二節段字元限制：${this.f.docNo2.errors?.maxlength.requiredLength}`;
    }
    if (this.f.docNo3.errors?.maxlength) {
      return `第三節段字元限制：${this.f.docNo3.errors?.maxlength.requiredLength}`;
    }
    if (this.f.docNo4.errors?.maxlength) {
      return `第四節段字元限制：${this.f.docNo4.errors?.maxlength.requiredLength}`;
    }
    if (this.f.docNo5.errors?.maxlength) {
      return `第五節段字元限制：${this.f.docNo5.errors?.maxlength.requiredLength}`;
    }
    return '';
  }

  getFlyNo1MaxLength(): number {
    if (!this.editForm || !this.editForm.get('shipMethod')) { return 0; }
    const shipMethod = this.editForm.get('shipMethod');
    if (!shipMethod) { return 0; }
    const v = shipMethod.value;
    if (v === '4') {
      return 17;
    }
    return 35;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();

    const exportDeclarationNo = this.routeStateService.getCurrent().data.exportDeclarationNo;

    try{
       this.exportHeader = await this.exportService.getExportHeader(exportDeclarationNo);
      // 等 API 回來
      const setting = await firstValueFrom(
        this.commonDataService.getAppCsmSetting('HKFacilitySetting')
      );

      // 設值
      this.isHkFacility = setting.appCsmSettingDetailList.some(
        (item: any) => item.setupValue === this.exportHeader.facility
      );

      console.log('isHkFacility:', this.isHkFacility);

       this.exportHeader.exportDtTimeZone = this.datePipe.transform(this.exportHeader.exportDt, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);

       this.exportHeader.flyDt1TimeZone = this.datePipe.transform(this.exportHeader.flyDt1, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);
       this.exportHeader.flyDt2TimeZone = this.datePipe.transform(this.exportHeader.flyDt2, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);

       var docNoArr = (this.exportHeader?.docNo || '').split('/');

       docNoArr.forEach((element: string, index: number) => {
         this.exportHeader['docNo' + (index + 1).toString()] = element;
         if (index == 1 && isNullOrEmpty(element)) {
           this.exportHeader['docNo' + (index + 1).toString()] = '  ';
         }
       });
        const controls = ['docNo1', 'docNo2', 'docNo3', 'docNo4', 'docNo5'];
        controls.forEach(field => {
        const control = this.editForm.get(field);
        if (!control) {
          return;
        }

        if (this.isHkFacility) {
          control.clearValidators();
        }

        control.updateValueAndValidity();
        });
       this.editForm.patchValue(this.exportHeader);


    }catch(err: any) {
      console.log('get export header occur error: ' + JSON.stringify(err));
    }

    //options
    this.facilityService.getLetterOrgOptions(this.exportHeader.facility, "").subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode}-${x.legalEntityOUName}`,
            value: x.legalEntityOUCode,
          };
        });
      }
    });

    this.facilityService.getForwarderOptions(this.exportHeader.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
      complete: () => {

      }
    });

    this.facilityService.getBillObjectOptions(this.exportHeader.facility, this.exportHeader.billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBillObjectTypeOptions().subscribe({
      next: result => {
        this.billObjectTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shipMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    forkJoin([
      this.facilityService.getDocTypeOptionsByFacilityCode('ALL'),
      this.facilityService.getDocTypeOptionsByFacilityCode(this.exportHeader.facility)
    ]).subscribe(([allOptions, facilityOptions]) => {
      this.docTypeOptions = [...facilityOptions.length ? facilityOptions : allOptions].map((x: any) => {
        const label = x.optionCode == x.optionDesc ? x.optionCode : `${x.optionCode}-${x.optionDesc}`;
        return {
          label,
          value: x.optionCode,
        };
      });
    });

    this.facilityService.getDocType1Options().subscribe({
      next: result => {
        this.docType1Dic = [...result];

        this.changeDocType1Options();
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currenyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getExportCodeOptions(this.exportHeader.facility).subscribe({
      next: result => {
        this.exportCodeOptions= [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.exportCodeOptions.unshift({
          label: "請選擇",
          value: ""
        });
      }
    });

    this.exportService.getCustomerOption().subscribe({
      next: result => {
        this.consigneeDic = [...result];
        this.consigneeOptions = [...result].map((x: any) => {
          return {
            label: `${x.customerCode}-${x.customerName}`,
            value: x.customerCode,
          };
        });
        this.consigneeOptions.unshift({
          label: "請選擇",
          value: ""
        });
      }
    });

    this.dropdownOptionService.getToCountryOptions().subscribe({
      next: (options: any[]) => {
        this.toCountryOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getAllCityOptions().subscribe({
      next: (options: any[]) => {
        this.allCityOptions = options.map(x => ({ label: x.name, value: x.seqNo.toString(), country: x.country }));
        this.toCityOptions = this.allCityOptions.filter(x => x.country == this.exportHeader.toCountry);
      },
    });



    forkJoin([
      this.translateService.get('ExportDeclarationDetails.Form.Forwarder'),
      this.translateService.get('ExportDeclarationDetails.Form.ExportMethod'),
      this.translateService.get('ExportDeclarationDetails.Form.PayeeType'),
      this.translateService.get('ExportDeclarationDetails.Form.OriginCurrenAnt'),
      this.translateService.get('ExportDeclarationDetails.Form.Payee'),
      this.translateService.get('ExportDeclarationDetails.Form.AccountCurrenAnt'),
      this.translateService.get(`ExportDeclarationDetails.Form${this.isHkFacility ? '.HK' : ''}.IdentificaitonNum`),
      this.translateService.get(`ExportDeclarationDetails.Form${this.isHkFacility ? '.HK' : ''}.FCAFOBPrice`),
      this.translateService.get('ExportDeclarationDetails.Form.DeliveryMode'),
      this.translateService.get('ExportDeclarationDetails.Form.FCAFOBPriceAccount'),
      this.translateService.get('ExportDeclarationDetails.Form.BillComp'),
      this.translateService.get('ExportDeclarationDetails.Form.PromotionFeeAccount'),
      this.translateService.get('ExportDeclarationDetails.Form.CustomerCode'),
      this.translateService.get('ExportDeclarationDetails.Form.MAWB'),
      this.translateService.get('ExportDeclarationDetails.Form.DeclarationDate'),
      this.translateService.get('ExportDeclarationDetails.Form.HAWB'),
      this.translateService.get('ExportDeclarationDetails.Form.DeclarationType'),
      this.translateService.get(`ExportDeclarationDetails.Form${this.isHkFacility ? '.HK' : ''}.FlightNum1`),
      this.translateService.get(`ExportDeclarationDetails.Form${this.isHkFacility ? '.HK' : ''}.FlightNum2`),
      this.translateService.get('ExportDeclarationDetails.Form.StatisticalMethods'),
      this.translateService.get('ExportDeclarationDetails.Form.FlightDate'),
      this.translateService.get('ExportDeclarationDetails.Form.Currency'),
      this.translateService.get('ExportDeclarationDetails.Form.Remarks'),
      this.translateService.get('ExportDeclarationDetails.Form.ExchangeRate'),
      this.translateService.get('ExportDeclarationDetails.Form.DomesticForeign'),
      this.translateService.get('ExportDeclarationDetails.Form.ChargeParty'),
      this.translateService.get('ExportDeclarationDetails.Form.BookingNo'),
      this.translateService.get('ExportDeclarationDetails.Form.PortOfLoadingDischargeName'),
      this.translateService.get('ExportDeclarationDetails.Form.ToCountry'),
      this.translateService.get('ExportDeclarationDetails.Form.ContainerNo'),
      this.translateService.get('ExportDeclarationDetails.Form.TypeOfPackage'),
      this.translateService.get('ExportDeclarationDetails.Form.ToCity'),
      this.translateService.get('ExportDeclarationDetails.Form.ConsigneeCompany1'),
      this.translateService.get('ExportDeclarationDetails.Form.ConsigneeCompany2'),
      this.translateService.get('ExportDeclarationDetails.Form.ConsigneeAddress1'),
      this.translateService.get('ExportDeclarationDetails.Form.ConsigneeAddress2'),
      this.translateService.get('ExportDeclarationDetails.Form.LetterOrgId'),
      this.translateService.get('ExportDeclarationDetails.Form.CreationTime'),
      this.translateService.get('ExportDeclarationDetails.Form.Creator'),
      this.translateService.get('ExportDeclarationDetails.Form.EditTime'),
      this.translateService.get('ExportDeclarationDetails.Form.UpdateBy'),
    ]).subscribe(([
      bookingForwarder,
      exportType,
      billObjectType,
      exportAmount,
      billObject,
      exportNtdAmount,
      docNo,
      freeOnBoardAmount,
      shipMethod,
      freeOnBoardNtdAmount,
      orgId,
      freeOnBoardChargeAmount,
      consigneeKey,
      mawbNo,
      exportDtTimeZone,
      expressBill,
      docType,
      flyNo1,
      flyNo2,
      docType1,
      flyDt,
      currency,
      reference,
      exchangeRate,
      exportCode,
      changeConsigneeId,
      bookingNo,
      portOfLoadingDischargeName,
      toCountry,
      containerNo,
      typeOfPackage,
      toCity,
      consigneeCompany1,
      consigneeCompany2,
      consigneeAddress1,
      consigneeAddress2,
      letterOrgId,
      createDt,
      createUser,
      updateDt,
      updateUser
    ]) => {
      this.columnNameMapping['bookingForwarder'] = bookingForwarder;
      this.columnNameMapping['exportType'] = exportType;
      this.columnNameMapping['billObjectType'] = billObjectType;
      this.columnNameMapping['exportAmount'] = exportAmount;
      this.columnNameMapping['billObject'] = billObject;
      this.columnNameMapping['exportNtdAmount'] = exportNtdAmount;
      this.columnNameMapping['docNo'] = docNo;
      this.columnNameMapping['freeOnBoardAmount'] = freeOnBoardAmount;
      this.columnNameMapping['shipMethod'] = shipMethod;
      this.columnNameMapping['freeOnBoardNtdAmount'] = freeOnBoardNtdAmount;
      this.columnNameMapping['orgId'] = orgId;
      this.columnNameMapping['freeOnBoardChargeAmount'] = freeOnBoardChargeAmount;
      this.columnNameMapping['consigneeKey'] = consigneeKey;
      this.columnNameMapping['mawbNo'] = mawbNo;
      this.columnNameMapping['exportDtTimeZone'] = exportDtTimeZone;
      this.columnNameMapping['expressBill'] = expressBill;
      this.columnNameMapping['docType'] = docType;
      this.columnNameMapping['flyNo1'] = flyNo1;
      this.columnNameMapping['flyNo2'] = flyNo2;
      this.columnNameMapping['docType1'] = docType1;
      this.columnNameMapping['flyDt'] = flyDt;
      this.columnNameMapping['currency'] = currency;
      this.columnNameMapping['reference'] = reference;
      this.columnNameMapping['exchangeRate'] = exchangeRate;
      this.columnNameMapping['exportCode'] = exportCode;
      this.columnNameMapping['changeConsigneeId'] = changeConsigneeId;
      this.columnNameMapping['bookingNo'] = bookingNo;
      this.columnNameMapping['portOfLoadingDischargeName'] = portOfLoadingDischargeName;
      this.columnNameMapping['toCountry'] = toCountry;
      this.columnNameMapping['containerNo'] = containerNo;
      this.columnNameMapping['typeOfPackage'] = typeOfPackage;
      this.columnNameMapping['toCity'] = toCity;
      this.columnNameMapping['consigneeCompany1'] = consigneeCompany1;
      this.columnNameMapping['consigneeCompany2'] = consigneeCompany2;
      this.columnNameMapping['consigneeAddress1'] = consigneeAddress1;
      this.columnNameMapping['consigneeAddress2'] = consigneeAddress2;
      this.columnNameMapping['letterOrgId'] = letterOrgId;
      this.columnNameMapping['createDt'] = createDt;
      this.columnNameMapping['createUser'] = createUser;
      this.columnNameMapping['updateDt'] = updateDt;
      this.columnNameMapping['updateUser'] = updateUser;
    });

    // 當 shipMethod 變更時，重新驗證 flyNo1
    this.editForm.get('shipMethod')?.valueChanges.subscribe(() => {
      this.editForm.get('flyNo1')?.updateValueAndValidity();
    });
  }

  getToCityOptions(event: any): void {
    this.editForm.value.toCity = null;
    this.toCityOptions = this.allCityOptions.filter(x => x.country == event.value);
  }

  orgChange(event: any): void{
    this.exportHeader.billObject = '76';
  }

  docTypeChange(event: any): void{
    var docType = this.exportHeader.docType;

    var docType1Value = "";
    var docType1ValueArr = this.docType1Dic.filter((x: any) => {
      return x.optionCode.startsWith(docType);
    }).map((x: any) => {
      return x.optionCode;
    });
    if(docType1ValueArr.length > 0){
      docType1Value = docType1ValueArr[0];
    }

    if(docType == "G5"){
      this.exportHeader.exportCode = "1";
      this.editForm.controls.docType1.setValue("G502");
    }else if(docType == "G3"){
      this.exportHeader.exportCode = "2";
      this.editForm.controls.docType1.setValue("G381");
    }else{
      this.exportHeader.exportCode = "";
      this.editForm.controls.docType1.setValue(docType1Value);
    }

    this.changeDocType1Options();
  }

  changeDocType1Options(): void{
    this.docType1Options = [...this.docType1Dic].filter((x: any) => {
      return x.optionCode.startsWith(this.exportHeader.docType);
    }).map((x: any) => {
      return {
        label: `${x.optionCode}-${x.optionDesc}`,
        value: x.optionCode,
      };
    });

    this.docType1Options.unshift({
      label: '請選擇',
      value: '',
    });
  }

  handleString(str: string): string{
    return isNullOrEmpty(str) ? "" : str;
  }

  saveBtn(event: any): void{
    const controls = this.editForm.controls;
    const errors : string[] = [];
    for (const column in controls) {
      const control = controls[column];
      if (!control?.errors) {
        continue;
      }
      if (!control.errors.maxlength) {
        continue;
      }
      errors.push(`${this.columnNameMapping[column]}: ${control.errors.maxlength.actualLength}/${control.errors.maxlength.requiredLength}`);
    }
    if (errors.length > 0) {
      this.toastService.error(`超越欄位長度限制錯誤，請修正後再儲存。\n${errors.join('\n')}`);
      return;
    }
    if (this.editForm.invalid) {
      //請檢查是否有必填欄位尚未填寫 需再修改json來源 from NewExport
      this.translateService.get('ExportDeclarationQuery.Alert.CheckRequiredFields')
      .subscribe({
        next: result => {
          this.toastService.warn(result);
        }
      });
      return;
    }
    //docNo & DateTime convert & customer
    this.exportHeader.docNo = `${this.handleString(this.exportHeader.docNo1)}/${this.handleString(this.exportHeader.docNo2)}/${this.handleString(this.exportHeader.docNo3)}/${this.handleString(this.exportHeader.docNo4)}/${this.handleString(this.exportHeader.docNo5)}`;
    if (this.isHkFacility) {
      this.exportHeader.docNo = this.exportHeader.docNo1;
    }
    this.exportHeader.exportDt = isNullOrEmpty(this.exportHeader.exportDtTimeZone) ? null : new Date(this.exportHeader.exportDtTimeZone).toISOString();
    this.exportHeader.flyDt1 = isNullOrEmpty(this.exportHeader.flyDt1TimeZone) ? null : new Date(this.exportHeader.flyDt1TimeZone).toISOString();
    this.exportHeader.flyDt2 = isNullOrEmpty(this.exportHeader.flyDt2TimeZone) ? null : new Date(this.exportHeader.flyDt2TimeZone).toISOString();
    this.exportHeader.consigneeKey = this.editForm.get('consigneeKey')?.value;
    this.exportHeader.changeConsigneeId = this.editForm.get('changeConsigneeId')?.value;
    this.exportHeader.updateUser = this.userProfile.loginAccount;
    if (this.exportHeader != null && this.isHkFacility) {
      let selectedFacility: any[] = [];
      selectedFacility = this.allCityOptions.filter(x => x.value == this.exportHeader.toCity);
      if (selectedFacility.length > 0) {
        if (!isNullOrEmpty(selectedFacility[0].label) ) {
          if (selectedFacility[0].label.toLowerCase().includes("hongkong")){
            this.toastService.error(this.translateService.instant("ExportDeclarationDetails.Message.HKAndSCDGToCityIsHK"));
            return;
          }
        }
      }
    }

    var consigneeName = this.consigneeDic.filter((x: any) => {
      return x.customerCode == this.exportHeader.consigneeKey;
    }).map((x: any) => {
      return x.customerName;
    });

    if(consigneeName.length > 0){
      this.exportHeader.consigneeName = consigneeName[0];
    }

    var changeConsigneeName = this.consigneeDic.filter((x: any) => {
      return x.customerCode == this.exportHeader.changeConsigneeId;
    }).map((x: any) => {
      return x.customerName;
    });

    if(changeConsigneeName.length > 0){
      this.exportHeader.changeConsigneeName = changeConsigneeName[0];
    }

    this.exportHeader.exportAmount = this.exportHeader.exportAmount ?? 0;
    this.exportHeader.freeOnBoardAmount = this.exportHeader.freeOnBoardAmount ?? 0;

    this.exportService.updateExport(this.exportHeader).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);
                this.routeStateService.navigateTo('/TransportOperation/ExportSearch', this.exportHeader);
              }
            });
      }
    });
  }

  changeBillObject(): void {
    const billObjectType = this.exportHeader.billObjectType;
    this.exportHeader.billObject = '';

    this.facilityService.getBillObjectOptions(this.exportHeader.facility, billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });
  }

  goToLastPage(): void {
    this.routeStateService.loadPrevious();
  }

}
